/**
 * Acesso Abrir/Espiar para conversa EXTERNA.
 * Não trata canal interno — o caller mantém o branch correspondente.
 *
 * @param {object} oUsuario - user do AuthContext (id, profile, queues, allTicket)
 * @param {{ queueId?: number|null, responsavelId?: number|null }} oTicket
 * @returns {boolean}
 */
export function usuarioPodeAcessarConversaExterna(oUsuario, oTicket) {
  if (!oUsuario) {
    return false
  }

  const cPerfil = oUsuario.profile
  if (cPerfil === "admin" || cPerfil === "supervisor") {
    return true
  }

  const nQueueId = oTicket?.queueId

  if (nQueueId == null) {
    if (oUsuario.allTicket === "enabled") {
      return true
    }
    return Number(oTicket?.responsavelId) === Number(oUsuario.id)
  }

  const mFilas = oUsuario.queues || []
  return mFilas.some((oFila) => Number(oFila.id) === Number(nQueueId))
}
